const ChatViewBtn = ({ disabled, onClick }) => {
    return (
        <button
            className="chat-view-button"
            onClick={onClick}
            disabled={disabled}
        >
            <i className="fa fa-expand mr-2" />View Form
        </button>
    );
};

export default ChatViewBtn;
